import React from 'react';
import { Navbar } from '../components/Navbar';
import { ProfilePage } from '../components/ProfilePage';
import { Footer } from '../components/Footer';
export const Profile = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2361">
      <Navbar data-id="element-2362" />
      <ProfilePage data-id="element-2363" />
      <Footer data-id="element-2364" />
    </div>;
};